import axios from 'axios';
import { getPreSignedUrl } from '../services/authApi/userApi';
import { toastNotify } from './toastNotify';

export const uploadIdentificationDocuments = async (uploadsData) => {
  const uploadPromises = uploadsData.map(async (data) => {
    try {
      const resp = await getPreSignedUrl(data.fileType, data.docType, data.displayView);
      const preSignedUrl = resp?.data?.url;
      const storagePath = resp?.data?.storagePath;

      if (preSignedUrl) {
        await axios.put(preSignedUrl, data?.file, {
          headers: { 'content-type': data?.fileType },
        });

        return {
          type: data.docType,
          [data.displayView.toLowerCase() + 'Url']: storagePath,
        };
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
      throw error;
    }
  });

  const results = await Promise.all(uploadPromises);

  return results.reduce((acc, docs) => {
    if (docs) {
      acc.type = docs.type;
      if (docs.frontUrl) acc.frontUrl = docs.frontUrl;
      if (docs.backUrl) acc.backUrl = docs.backUrl;
    }
    return acc;
  }, {});
};
